import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import locales from 'text!app-locale';
import moment from 'moment';
import $ from 'jquery';
import _ from 'lodash';

export default ['$translate', 'LOCALE_INFO', '$rootScope', 'tmhDynamicLocale', '$q', 'LOCALE_CHANGE_EVENT_NAME', function ($translate, LOCALE_INFO, $rootScope, tmhDynamicLocale, $q, LOCALE_CHANGE_EVENT_NAME) {
    /* --- VARS --- */
    var localesObj = LOCALE_INFO.locales;
    var missingLocales = {};

    // get locales and locales display names
    var _LOCALES = Object.keys(localesObj);
    if (!_LOCALES || _LOCALES.length === 0) {
        console.error('There are no _LOCALES provided');
    }
    var _LOCALES_DISPLAY_NAMES = [];
    _LOCALES.forEach(function (locale) {
        _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
    });

    /**
     * A promise for when angular-translate is loaded and translations are provided
     * @type {{Q.Promise}}
     */
    var translateReadyDeferred = $q.defer();

    var localeInfo = JSON.parse(locales);
    var currencySymbols = {
        'aud': '$',
        'cad': '$',
        'eur': '\u20AC',
        'gbp': '\xA3',
        'jpy': '\xA5',
        'rub': '\u20BD',
        'usd': '$',
        'chf': 'Fr.',
        'cny': '\xA5',
        'nzd': '$'
    };

    var currencySymbolList = _.values(currencySymbols);

    var currentLocale = void 0;
    var currentLanguageVariant = '';

    if (ApplicationFeatures.hasFeature('languageVariant')) {
        currentLanguageVariant = ApplicationFeatures.getAllFeatures().languageVariant;
    }

    /* --- METHODS --- */
    var checkLocaleIsValid = function checkLocaleIsValid(locale) {
        return _LOCALES.indexOf(locale) !== -1;
    };

    var onSettingLocale = function onSettingLocale(locale, languageVariant) {
        document.documentElement.setAttribute('lang', locale.replace('_', '-')); // set "lang" attribute to html
        $rootScope.$broadcast(LOCALE_CHANGE_EVENT_NAME, locale, languageVariant);
    };

    var setLocale = function setLocale(locale) {
        if (!checkLocaleIsValid(locale)) {
            console.error('Locale name "' + locale + '" is invalid');
            return;
        }
        startLoadingAnimation();

        currentLocale = locale;
        $translate.use(locale);

        whenTranslateReady().then(stopLoadingAnimation);
    };

    function whenTranslateReady() {
        return translateReadyDeferred.promise;
    }

    /**
     * Stop application loading animation when translations are loaded
     */
    var $html = angular.element('html');
    var LOADING_CLASS = 'app-loading';

    // remove the app main loader when app is starting
    // LOADING_CLASS would be removed when it's started and l10n is loaded
    $('.gw-app-main-loader').remove();

    function startLoadingAnimation() {
        $html.addClass(LOADING_CLASS);
    }

    function stopLoadingAnimation() {
        $html.removeClass(LOADING_CLASS);
    }

    function getTargetLocaleCode(languageCode, countryCode) {
        var possibleLocaleCode = languageCode + '-' + countryCode;

        if (missingLocales[possibleLocaleCode]) {
            return missingLocales[possibleLocaleCode];
        }

        return possibleLocaleCode;
    }

    /**
     * Set locale for moment.js (is used in datepicker component)
     * moment.js is loaded with locale included => synchronous change
     * @param {string} targetLocaleCode - locale code you wish to change moments locale to.
     * @param {string} languageCode - language code for target locale
     */
    function setLocaleForMomentJs(targetLocaleCode, languageCode) {
        if (moment.locale(targetLocaleCode) !== targetLocaleCode) {
            // if locale isn't provided by moment.js
            if (languageCode === 'zh') {
                // no moment zh.js default to zh-cn.js
                moment.locale('zh-cn');
            } else {
                moment.locale(languageCode); // language
            }
        }
    }

    /* --- EVENTS --- */
    $rootScope.$on('$translateChangeSuccess', function (event, data) {
        onSettingLocale(data.language, currentLanguageVariant);

        var languageComponents = data.language.split('_');
        var languageCode = languageComponents[0];
        var countryCode = localeInfo.country.code.toLowerCase();

        var targetLocaleCode = getTargetLocaleCode(languageCode, countryCode);

        setLocaleForMomentJs(targetLocaleCode, languageCode);

        if (tmhDynamicLocale.get() !== targetLocaleCode) {
            tmhDynamicLocale.set(targetLocaleCode); // load Angular locale
        }
        translateReadyDeferred.resolve();
    });

    $rootScope.$on('$localeChangeSuccess', function () {
        stopLoadingAnimation();
    });

    $rootScope.$on('$localeChangeError', function (event, data) {
        var comp = data.split('-');
        if (comp.length > 1) {
            missingLocales[data] = comp[0];
            tmhDynamicLocale.set(comp[0]);
        } else {
            stopLoadingAnimation();
        }
    });

    /* --- INIT --- */
    function onInit() {
        // store current locale
        currentLocale = $translate.proposedLanguage() || $translate.use(); // because of async loading
        onSettingLocale(currentLocale, currentLanguageVariant);
    }

    function hideMaskOnJPLocale() {
        return localeInfo.phone.UserDefaultPhoneCountry === 'JP' ? '' : localeInfo.phone.sample;
    }

    onInit();

    /* --- RETURN --- */
    return {
        getCountry: function getCountry() {
            return localeInfo.country;
        },
        getLocaleDisplayName: function getLocaleDisplayName() {
            return localesObj[currentLocale];
        },
        setLocaleByDisplayName: function setLocaleByDisplayName(localeDisplayName) {
            setLocale(_LOCALES[_LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName) // get locale index
            ]);
        },
        getCurrentLocale: function getCurrentLocale() {
            return currentLocale;
        },

        getCurrentLanguage: function getCurrentLanguage() {
            if (currentLocale) {
                if (currentLocale.indexOf('_') > -1) {
                    return currentLocale.split('_').shift();
                }

                return currentLocale;
            }

            throw new Error('Unknown language');
        },

        getLocalesDisplayNames: function getLocalesDisplayNames() {
            return _LOCALES_DISPLAY_NAMES;
        },
        getCurrencySymbol: function getCurrencySymbol(currency) {
            return currencySymbolList.includes(currency) ? currency : currencySymbols[currency] || '\xA4';
        },
        getNameConfig: function getNameConfig() {
            return localeInfo.name;
        },
        getAddressConfig: function getAddressConfig() {
            return localeInfo.address;
        },
        getLocaleInfo: function getLocaleInfo() {
            return localeInfo;
        },
        getRegionSamplePhoneNumber: function getRegionSamplePhoneNumber() {
            return hideMaskOnJPLocale();
        },
        getConfiguredPhoneRegion: function getConfiguredPhoneRegion() {
            return localeInfo.phone.UserDefaultPhoneCountry;
        },

        whenTranslateReady: whenTranslateReady
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/l10n/LocaleService.js
// module id = 1042
// module chunks = 0